import Carousel from 'utils/carousel/carousel';

export default function initCarousels() {
  const targets = document.querySelectorAll('[data-carousel]');

  return Array.from(targets).map(x => new Carousel(x).init());
}
